module.exports = __webpack_public_path__ + "img/full0-min.e0a764e2.png";